export default "__VITE_ASSET__BO3nNHMN__"